import React from 'react';
import { graphql } from 'gatsby';

import MainLayout from '../layouts/main';
import { AllProjectsJson, AllTagsJson } from '../../types/common';
import Carousel from '../carousel/Carousel';
import CardTag from '../tag/Tag';
import ContactBtn from '../button/ContactBtn';

export const query = graphql`
  query ($slug: String!) {
    allProjectsJson(filter: { slug: { eq: $slug } }) {
      edges {
        node {
          id
          title
          description
          tags
          img {
            path {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  width: 1200
                  layout: CONSTRAINED
                )
              }
            }
          }
          finishDate
          repository
          url
        }
      }
    }
    allTagsJson {
      edges {
        node {
          id
          tag
          color
          tagId
        }
      }
    }
  }
`;

type ProjectType = {
  data: {
    allProjectsJson: AllProjectsJson;
    allTagsJson: AllTagsJson;
  };
};

const Project = ({ data }: ProjectType) => {
  const { allProjectsJson, allTagsJson } = data;
  const project = allProjectsJson.edges[0].node;
  const tags = allTagsJson.edges.map((edge) => edge.node);
  const projectTags = tags.filter((tag) => project.tags.includes(tag.tagId));
  const projectImages = project.img.map(
    (image) => image.path.childImageSharp.gatsbyImageData
  );

  return (
    <MainLayout>
      <div className="flex flex-col justify-center items-center gap-3">
        <Carousel images={projectImages} />
        <div className="flex flex-col w-full max-w-4xl gap-4 justify-between">
          <h1 className="text-2xl  md:text-4xl font-bold">{project.title}</h1>
          <div>
            <h2 className="lg:text-lg">Description:</h2>
            <p className="text-accentGray w-full text-md lg:text-lg  text-justify">
              {project.description}
            </p>
          </div>
          <div className="flex flex-wrap gap-4">
            {projectTags.map((tag) => (
              <CardTag tagColor={tag.color} tag={tag.tag} key={tag.id} />
            ))}
          </div>
          <div className=" flex flex-wrap md:flex-row gap-4">
            <a href={project.url}>
              <ContactBtn
                backgroundColor="bg-gradient-to-br from-pink-500 to-orange-400 group-hover:from-pink-500 group-hover:to-orange-400
               dark:text-white"
              >
                View Website
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 
                  1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </ContactBtn>
            </a>
            <a href={project.repository}>
              <ContactBtn
                backgroundColor="bg-gradient-to-br from-pink-500 to-orange-400 group-hover:from-pink-500 
              group-hover:to-orange-400 hover:text-white dark:text-white"
              >
                Project Repository
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z" />
                  <path d="M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z" />
                  <path d="M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z" />
                </svg>
              </ContactBtn>
            </a>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Project;
